import { Alert } from "@mui/material";
import * as React from "react";
import { P, Content,H1 } from "../recurso_literario.js";
import { useContext } from "react"
import { DomainContext } from "../../Context/Context.js";

export const Conceptos = (props)=>{
	const { cloudName, } = useContext(DomainContext)

    return (
	<Content>
		<H1> Conceptos </H1>

		<P>
			Para que le saques todo el provecho a {cloudName}, es necesario que
			manejes algunos conceptos propios de las nubes y en particular de {cloudName}.
		</P>
	</Content>
	)
}

export const ConCloud = (props)=>{
	const { domainName, cloudName } = useContext(DomainContext)

    return (
	<Content>
		<H1> Nube </H1>

		<P>
			Una nube es un espacio virtual donde vas a poder desplegar elementos
			virtuales y con ellos construir la solución que necesitás. 
			{ domainName === "Telecom" && " No es importante " + 
			"dónde está físicamente la nube. Basta que sepas que se compone por infraestructura " +
			"de Telecom y que se encuentra construida dentro de los data centers de Telecom " +
			"sobre suelo Argentino."}
		</P>
		<h2> Autogestión </h2>
		<P>
			Podrás desplegar, eliminar, modificar todos los elementos que ofrece {cloudName} para 
			armar tus soluciones sin la necesidad de comunicarte con {domainName}.
			Esto te da la libertad y velocidad que necesitás para armar soluciones
			de manera rápida y efectiva.
		</P>
		<h2> Pago por uso </h2>
		<P>
			Pagás por lo que usás. A medida que vas desplegando recursos como ser una VM,
			te informará la plataforma cuál es el precio por hora de dicho recurso. Cuando
			liberás el recurso, la plataforma deja de contabilizarlo y a fin de mes sólo
			deberás pagar por el tiempo que tuviste ese recurso instanciado durante el mismo.
		</P>

		<h2> Direccionamiento IP dentro de la nube </h2>

		<P>
			Cada nube es independiente de otra nube y no comparte elementos o direccionamiento
			IP con otra nube. Cada nube cuenta con la red 10.0.0.0/8 la cual vas a poder
			subnetear en subredes según tus necesidades. Tené en cuenta lo anteriormente
			mencionado: “Cada nube es completamente independiente de otra nube”.  Esta regla
			se da aun cuando las nubes sean todas de tu propiedad.
		</P>

		<h2> Acceso a Internet </h2>

		<P>
			Las nubes cuentan con un router de borde con una IP pública asignada por defecto.
			Éste es tu punto de salida hacia internet. Pero no es tu punto de entrada.
			Para ello existen las IP Públicas de la sección de Network{ /*(hacer un link a la sección)*/}.
			Dependiendo de cómo hayas configurado las políticas de seguridad descritas en la
			sección políticas de seguridad{/*(ponerle un link a dicha sección)*/}, tus VM podrán
			tener acceso a Internet. La interfaz del router de borde que conecta hacia Internet,
			cuenta con un ancho de banda establecido que podrás modificar según tus necesidades.
			Cada ancho de banda conlleva un costo por hora. Vas a poder elegir entre una gran
			gama de opciones preestablecidas de anchos de banda entre simétricos y asimétricos.
		</P>

		<h2> Trabajando sobre una nube </h2>
		
		<P>
			{cloudName} te permite tener muchas nubes y gestionar todas ellas desde la misma
			interfaz. En la parte superior izquierda de la pantalla podés observar en cuál de
			tus nubes te encontrás situado trabajando.
		</P>

		<P>
			<img src="/img/Cloud/Cloud1.png" alt="Selección de Nube"/>
		</P>

		<P>
			Para poder visualizar dicha nube en el selector y poder acceder a ella, el usuario con
			el que autenticaste debe tener los permisos suficientes. Caso contrario no visualizarás
			la nube y no podrás cambiar a ella para trabajar. Si esto ocurre deberás utilizar
			alguno de tus usuarios con permisos suficientes para otorgarle acceso al usuario con
			el que estás teniendo problemas. Para más información ir a la sección Permisos de usuario y Grupos.
		</P>

		<h2> Acciones sobre una nube </h2>

		<P> El ícono del engrane a la derecha del selector de nube te permitirá desplegar un menú con
			acciones que podrás realizar sobre la nube seleccionada
		</P>

		<P>
			<img src="/img/Cloud/Cloud2.png" alt="Acciones de Nube"/>
		</P>

		<h3> Cambiar el nombre de la nube </h3>

		<P>
			Te permite cambiar el nombre a la nube para que te sea más fácil reconocerla
		</P>

		<P>
			<img src="/img/Cloud/Cloud3.png" alt="Cambiar numbre Nube"/>
		</P>

		<h3> Cambiar ancho de banda </h3>

		<P>
			Te permite cambiar la política de ancho de banda de la nube. Cada política te ofrece
			un ancho de banda de salida y de entrada específicos. Además, cada una de ellas tiene
			asociado un costo por hora. Podrás cambiar de política las veces que lo desees.
		</P>

		<P>
			<img src="/img/Cloud/Cloud4.png" alt="QoS Nube"/>
		</P>

		<h3> Eliminar la nube </h3>

		<P>
			Esta acción dispara la eliminación de la nube en la que te encontrás. La misma conlleva
			varios pasos para asegurarnos que efectivamente deseas dar de baja la nube. Una vez 
			constatado que deseas darte de baja, se procederá a la eliminación de la nube.
		</P>

		<P>
			El único usuario que puede dar de baja una nube es el usuario ROOT. No visualizarás la
			opción que te permite dar de baja una nube si utilizás otro usuario.
		</P>

		<Alert severity="info">
			Tendrás un período de 20 días desde que pediste la baja para arrepentirte y recuperar tu
			nube en el mismo estado en que se encontraba al momento de pedir la baja. Para dar
			constancia de tu arrepentimiento debes contactarte con tu ejecutivo de cuenta.
		</Alert>
		<br/>
		<P>
			La eliminación de una nube sólo puede realizarse con el usuario ROOT. Ningún otro
			usuario que hayas creado en tus nubes tiene la potestad para eliminar una nube. Si el
			usuario con que te autenticaste no es el ROOT entonces no visualizarás en el menú la
			opción de eliminar la nube. Al hacer clic en el menú que elimina una nube, se te pedirá
			en primera instancia que ingreses el nombre tal cual aparece escrito de la misma.
		</P>

		<P>
			<img src="/img/Cloud/Cloud5.png" alt="Eliminacion Nube nombre"/>
		</P>

		<P>
			Luego se te pedirá que ingreses el motivo entre algunas opciones y, si lo deseas, que
			nos des un poco más de información. Nos será de mucha utilidad para mejorar el servicio.
		</P>

		<P>
			<img src="/img/Cloud/Cloud6.png" alt="Eliminacion Nube motivo"/>
		</P>

		<P>
			Para finalizar, te pediremos como última comprobación que ingreses nuevamente las
			credenciales del usuario ROOT.
		</P>

		<Alert severity="error">
			El último paso en el que ingresás las credenciales del usuario ROOT termina por
			disparar la baja.
		</Alert>
		<br/>
	</Content>
	)
}

export const ConNetworks = (props)=>{
	const { domainName, cloudName } = useContext(DomainContext)
    return (
	<Content>
		<H1> Network </H1>
		<P>
			{cloudName} te ofrece las herramientas necesarias para que armes la
			topología de red de tu nube como más te convenga.
		</P>
		<h2> Subred </h2>
		<P>
			Cada nube {cloudName} es un datacenter virtual. Cada datacenter virtual
			tiene su propio direccionamiento IP dentro del bloque 10.0.0.0/8.
			Vas a poder subnetear dicha red en bloques
			más pequeños para armar la arquitectura de tu red. Por ejemplo, podrías
			decidir tener dos subredes como ser 10.0.0.1/24 y 10.0.0.2/24. Vas a poder
			subdividir la red 10.0.0.0/8 como quieras siempre que respete los conceptos
			de Networking.
		</P>
		<P>
			Cada red cuenta con un DHCP que podés utilizar al momento de asignar las
			IP a tus dispositivos dentro de la nube o podés optar por colocar la
			IP que desees. Siempre dentro del rango establecido para la subred que
			armaste.
		</P>

		<h2> Puerto </h2>
		<P>
			Un puerto es un punto de conexión para conectar un único dispositivo,
			como la NIC de un servidor virtual, a una red virtual. Quienes pueden
			tener puertos en una red virtual son las VM y Routers. El puerto también
			describe la configuración de red asociada, como las direcciones MAC e IP
			que se utilizarán en ese puerto.
		</P>

		<h2> DHCP </h2>
		<P>
			Todas las subredes creadas tendrán un servicio de DHCP(Dynamic Host
			Configuration Protocol). Un servidor DHCP entrega las direcciones IP a
			los hosts de la red, que son los clientes DHCP.
		</P>
		<P>
			Los clientes DHCP localizan el servidor DHCP enviando un paquete UDP desde
			el puerto 68 a la dirección 255.255.255.255 en el puerto 67. La dirección
			255.255.255.255 es la dirección de transmisión de la red local: todos los
			hosts de la red local ven los paquetes UDP enviados a esta dirección. Sin
			embargo, dichos paquetes no se reenvían a otras redes. En consecuencia, el
			servidor DHCP debe estar en la misma red local que el cliente o el servidor
			no recibirá la transmisión. El servidor DHCP responde enviando un paquete
			UDP desde el puerto 67 al puerto 68 del cliente.
		</P>
		<Alert severity="info">
			Si el puerto de tu VM no tiene un Grupo de Seguridad que permita el tráfico
			saliente al puerto UDP 67, entonces tu VM tendrá problemas para obtener
			IP mediante el servicio DHCP. Aún cuando veas en el Dashboard que dicho
			puerto tiene IP. Ver en el Dashboard la IP en el puerto significa que
			esa es la IP que la VM le solicitará al DHCP.
		</Alert>
		<br/>
	</Content>
	)
}

export const ConProject = (props)=>{
    return (
	<Content>
		<H1> Proyectos </H1>

		<P>
			Los proyectos son agrupaciones de elementos dentro de una Nube. Te permiten
			tener organizados los elementos de la nube bajo algún criterio. Por ejemplo, 
			por área o servicio o proyecto.
		</P>

		<P>
			Imaginá que sos una empresa que se dedica al desarrollo de aplicaciones; podrías
			tener un “proyecto A” para aquellos que se encuentran desarrollando una aplicación
			y “proyecto B” para quienes se encuentran desarrollando otra aplicación. Todos los
			elementos de nube tienen que estar en un proyecto y no puede haber elementos en
			dos o más proyectos al mismo tiempo.
		</P>

		<P>
			Los proyectos también te permiten una mejor gestión de usuarios y grupos de
			usuarios. Vas a poder indicar qué usuario o grupo de usuarios pueden hacer qué
			acción dentro de un proyecto. Por ejemplo, un grupo de usuario podría tener el
			permiso necesario para prender/apagar las VM de un proyecto, pero no para
			modificarlas, borrarlas o crear más VMs en dicho proyecto.
		</P>

		<P>
			Hay dos tipos de elementos que, si bien han de declararse dentro de un proyecto
			(recuerda que todo elemento debe estar dentro de un proyecto), vas a poder
			utilizarlos y visualizarlos en otros proyectos. Éstos son:

			<ul>
				<li>Red</li>
				<li>Política de Seguridad</li>
			</ul>
		</P>
	</Content>
	)
}

export const ConNetworking = () => {
	const { cloudName } = useContext(DomainContext)

    return(
		<Content>
		<H1>Networking</H1>

		<P>
			{cloudName} te permite armar una infrastructura virtual de red a la medida de tus necesidades.
			En este apartado podrás obtener información de los elementos que puedes utilizar para armar
			dicha infrastrcutura.
		</P>

        </Content>
	)
}

export const ConRouters = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<H1> Routers </H1>

		<P>
			Los routers son dispositivos virtuales que permiten conectar redes entre
			ellas.
		</P>
		<P>
			Toda nube {cloudName} posee un router de borde que conecta tu nube
			con Internet. Éste router no es administrable y sólo cumple con la
			función de otorgarle a tu red el acceso a Internet.
		</P>
		<P>
			Cuando creas una subred, si deseas que desde dicha subred se acceda a
			Internet o que las VM dentro de dicha subred tengan acceso a Internet,
			deberás indicarle a la plataforma que la subred debe estar conectada
			al router de borde.
		</P>
		<P>
			Con {cloudName} puedes configurar el ancho de banda que tendrá el
			puerto del router de borde contra Internet. Cada configuración de
			ancho de banda tiene un precio asociado por hora.
		</P>
	</Content>
	)
}

export const ConSG = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<h1> Grupos de Seguridad </h1>
		<P>
			Proporcionan el mecanismo para definir políticas de firewall que luego se
			podrán aplicar a los puertos. Las políticas están compuestas por reglas
			que te permitirán determinar el tráfico entrante y saliente para dicha
			política. Cada puerto puede hacer referencia a uno o más grupos de seguridad.
		</P>
		<P>
			Cada {cloudName} posee una política de seguridad por defecto que puede
			ser modificada o eliminada. Dicha política permite todo el tráfico
			saliente y deniega todo el tráfico entrante. Es la política que se
			aplica por defecto a los puertos de las VM al ser creadas.
		</P>
	</Content>
	)
}

export const ConVPN = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<H1>VPN</H1>

		<P>
			El servicio de VPN se implementa mediante máquinas virtuales que viene ya instaladas
			con el software PFSense. Vas a poder desplegar tantas VM con PFSense como necesites aunque
			por lo general basta con una sola. 
		</P>
		<P>
			Si bien el PFSense que se ofrece está pensado para que puedas disponer de una VPN, eso no
			implica que puedas aprovechar de todas las características del PFSense.
		</P>
		<P>
			La principal diferencia entre una VM tradicional y una VM desplegado como servicio de VPN, es
			que la primera no tiene una interfaz en la WAN y para que se pueda acceder desde Internet a la
			misma se necesita adjuntar una IP pública (ver la sección de Networking IP pública). En el caso
			de una VM desplegada como servicio de VPN, la misma ya cuenta con una interfaz con IP pública
			y no es necesario adjuntar otra IP.
		</P>
		<P>
			Respecto de las interfaces sobre una red LAN, vas a poder crear tantas como necesites sobre tus
			redes LAN.
		</P>
		<P>
			En la siguiente imagen se puede apreciar la WAN en violeta y una LAN en verde y cómo una
			VM desplegada como servicio de VPN PFSense, se conecta directamente contra la WAN. Ahora bien,
			esto implica que las VM tradicionales podrán sacar su tráfico por dos interfaces distintas,
			la del router de borde y la de la VM con PFSense. Será necesario pues, que para que el servicio
			de VPN funcione, configures como default gateway la interfaz con IP privada de tu PFSense. En el
			ejemplo de la imagen sería la interfaz del PFSense que se conecta con la red verde. Puedes encontrar
			un ejemplo completo en la sección "Tareas" de este mismo documento.
		</P>
		<P>
			<img src="/img/VPN/vpn1.png" alt="Esquema básico de VPN" style={{marginLeft:"40px"}} />
		</P>

		<H1>Ancho de banda</H1>
		<P>
			Vas a poder controlar el ancho de banda que tendrá en la WAN el PFSense a fin de que puedas
			acomodarlo a tus necesidades. Cada configuración de ancho de banda tiene su precio por hora.
			El ancho de banda solo afecta a la WAN. Las LAN no poseen ancho de banda establecido y siempre
			se intentará ofrecer lo máximo que se pueda.
		</P>

		<H1>Pago por uso</H1>
		<P>
			El precio por hora de las VM que ofician de PFSense se puede dividir en tres items.
			Poder de cómputo: De momento solo se ofrece 
		</P>
		<P>
			Si apagas la VM del PFSense, dejará de contabilizarse el monto por hora del ancho de banda. En
			el instante en que la enciendas nuevamente, se comenzará a contabilizar nuevamente el ancho de
			banda.
		</P>
		<H1>Seguridad</H1>
		<P>
			Para que el PFSense funcione como terminador de VPN, no es posible asignarle grupos de seguridad
			en sus interfaces. Ni en la WAN, ni en la o las LAN. El filtrado de IP y puertos debe ser configurado
			en el mismo PFSense.
		</P>
		<H1>Consola WEB</H1>
		<P>
			La consola WEB la podrás accesar desde una VM desde la cual alcances alguna de las IP privadas
			que tenga el PFSense. Utiliza un navegador WEB colocando la IP de alguna de las privadas.
		</P>
	</Content>
	)
}

export const ConPublicIP = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<h1> IP Públicas  </h1>
		<P>
			Las IP Públicas son IPv4 ruteables en Internet que podrás adquirir y asociar a las
			interfaces de las VM y Balanceadores. Ésta es la forma de dotar a una VM de la
			capacidad
			de que sea accedida desde Internet. Por ejemplo, si se desea que dicha
			VM ofrezca un servicio http o https al cual se deba acceder desde Internet.
		</P>
		<P>
			Las IP Públicas se pueden asignar a puertos de VM siempre que el puerto
			pertenezca a una subred que está conectada al router de borde.
		</P>
		<P>
			Una vez que adquirís una IP Pública, será tuya hasta que decidas liberarla.
			Aún cuando no la tengas asociada a puerto alguno. Las IP Públicas se
			facturan por hora. Las IP adquiridas, pero no asignadas a un puerto, tienen
			un costo mayor.
		</P>
	</Content>
	)
}

export const ConLBaaS = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<H1> Balanceadores de carga </H1>
		<P>
			El servicio de Balanceo de Carga (LBaaS en adelante) permite redirigir el tráfico
			de red desde un punto de ingreso hacia uno o varios destinos.
		</P>
		<P>
			Un LBaaS además permite armar un esquema de alta disponibilidad de servicios.
			Ya que puede ser configurado para que deje de redirigir el tráfico a un destino que
			determina con problemas para manejar dicho tráfico.
		</P>
		<P>
			Un LBaaS ofrece la capacidad de escalar un servicio de manera horizontal, sumando destinos.
		</P>
		<h2>Ejemplo de solución con y sin LBaaS</h2>
		<P>
			Supongamos que hemos desarrollado un sitio WEB el cual deseamos siempre esté en línea.
			Sin un servicio de LBaaS, una solución factible sería desplegar dos servidores virtuales,
			colocarle a cada uno una IP pública y luego mediante resolución de DNS indicar que
			nuestro FQDN apunte a dichas IP públicas. La alternativa es usar el servicio LBaaS.
		</P>
		<h3>Balanceando mediante DNS</h3>
		<P>
			<img src="/img/LBaaS/LBaaS01.png" alt="Balanceo mediante DNS" style={{marginLeft:"40px"}} />
		</P>
		<P>
			Este esquema presenta varios problemas:
			<ul>
				<li><b>Es caro.</b> Porque se deben contratar dos IP públicas. Ni que decir si se
					incrementa la cantidad de VM.</li>
				<li><b>No escala horizontalmente de manera fácil.</b> Si queremos agregar una tercera
					VM debemos crear la VM, asignarle una IP pública e indicar a nuestro DNS que
					debe agregar otra entrada para www.misitio.com que apunte a la nueva IP.</li>
				<li><b>No ofrece alta disponibilidad completa.</b> En este caso el balanceo lo hace el
					DNS. Cuando alguien desea ver nuestro sitio, el navegador consulta al servicio de
					DNS para obtener la IP. El servicio de DNS retornará de forma aleatoria alguna
					de las IP pero no verifica si lo que está detrás de dicha IP responde o no.</li>
				<li><b>No permite el mantenimiento.</b> Si se desea trabajar sobre uno de los hosts
					quitándolo de producción momentáneamente, deberíamos remover la entrada de DNS.
					Caso contrario el servicio de DNS podría seguir entregando la IP pública del
					host que ha quedado fuera de línea por estar recibiendo mantenimiento.</li>
			</ul>
		</P>
		<h3>Balanceo usando el servicio LBaaS</h3>
		<P>
			<img src="/img/LBaaS/LBaaS02.png" alt="Balanceo mediante LBaaS" style={{marginLeft:"40px"}} />
		</P>
		<P>
			Con el servicio de LBaaS todos los problemas antedichos desaparecen.
			<ul>
				<li><b>Es más barato.</b> Solo necesitamos una IP pública donde definir el punto de
					acceso que recibirá todo el tráfico. A nivel DNS solo necesitamos apuntar nuestro
					FQDN www.misitio.com a dicha IP pública. Luego como parte de la configuración del
					LBaaS se indica que todo el tráfico recibido debe ser enviado a nuestros dos host
					mediante alguna política que nos convenga.</li>
				<li><b>Escala horizontalmente.</b> Porque podemos sumar la cantidad de host que deseemos sin
					la necesidad de alterar el DNS o contratar más IP públicas.</li>
				<li><b>Ofrece alta disponibilidad real.</b> El LBaaS puede ser configurado para que chequee
					periódicamente el estado de cada uno de los host. Si encuentra que alguno no cumple
					con lo necesario, deja de enviarle tráfico hasta que cambie su situación.</li>
				<li><b>Permite el mantenimiento.</b> Es posible indicarle que deje de enviar tráfico a un host
					para prestarle mantenimiento sin que por ello se vea afectado el servicio.</li>
			</ul>
		</P>
		<H1> NAT y PAT </H1>
		<P>
			El servicio de LBaaS le permite realizar configuraciones de Network Address Traslation
			(NAT en adelante) y de Port Address Translation (PAT en adelante). Esto permite utilizar una
			sola IP flotante para ofrecer más de un servicio en distintos puertos.
		</P>
		<P>
			Supongamos que deseamos ofrecer un sitio web en el puerto TCP 80 y un servicio de mail relay en el
			puerto TCP 25 y por algún motivo los dos servicios están en VM distintas. Sin un LBaaS deberíamos
			asignarle una IP pública a cada VM. Lo que conlleva a mayores costos. Más aún, si luego aparecen
			otros servicios que deseemos ofrecer a nuestros clientes y debemos desplegarlos en distintas VM.
		</P>
		<P>
			Con un LBaaS podemos ofrecer todos los servicios sobre la misma IP pública (siempre que no se
			repita el puerto para el mismo protocolo) y es el LBaaS quien redirige el tráfico a la o las
			VM correctas. Aún a puertos distintos. 
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS03.png" alt="NAT y PAT" style={{marginLeft:"40px"}} />
		</P>
		<H1> Estados de servicio de un LBaaS </H1>
		<P>
			Un LBaaS puede pasar por los siguientes estados operativos:
			<ul>
				<li><b>ONLINE:</b> Operando con normalidad</li>
				<li><b>OFFLINE:</b> Administrativamente se ha decidido que el LBaaS deje de estar operativo</li>
				<li><b>ERROR:</b> El LBaaS presenta un error y necesita asistencia del proveedor</li>
			</ul>
		</P>
		<P>
			Podemos corroborar el estado operativo del LBaaS en la lista de ellos
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS05.png" alt="Estado operativo LBaaS en detalle" style={{marginLeft:"40px"}} />
		</P>
		<P>
			O en el detalle de uno en particular
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS04.png" alt="Estado operativo LBaaS en listado" style={{marginLeft:"40px"}} />
		</P>
	</Content>
	)
}

export const ConLBaaSListener = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<H1>Puntos de Acceso</H1>

		<P>
		Los Puntos de Acceso (o listener en inglés) es la configuración que define el protocolo y puerto
		que escucha dicho tráfico y lo encamina luego al grupo para que lo redirija al host adecuado.
		</P>
		<P>
		Un balanceador puede contar con uno o varios puntos de acceso. La restricción es que, dentro
		de un mismo LBaaS no puede haber dos puntos de acceso con el mismo puerto para el mismo protocolo.
		</P>
		<P>
		Un Punto de Acceso cuenta con los siguientes atributos:
		<ul>
			<li><b>Nombre: </b>Un nombre que describa al punto de acceso.</li>
			<li><b>Protocolo: </b>El protocolo que escucha en el punto de acceso. El protocolo determinará
			la forma en la que se comportará el Punto de Acceso  antes dicho tipo de tráfico. Podemos elegir uno de
			los siguientes protocolos de capa de transporte (capa 3 del modelo OSI) y algunos de capa de
			aplicación (capa 7 en el modelo OSI). De capa de transporte tenemos TCP, UDP y SCTP. De capa de
			aplicación tenemos HTTP, HTTPS.  En el apartado “Protocolo del Punto de Acceso” se indica la
			diferencia entre ellos y cuál es el mejor a ser seleccionado dependiendo de las necesidades.</li>
			<li><b>Puerto: </b>Puerto del protocolo seleccionado.</li>
			<li><b>Grupo de balanceo: </b>Es el grupo a donde se enviará el tráfico para que sea atendido
			por alguno de sus miembros. Hay dos motivos por los cuales podría no indicarse un grupo. El primero
			es que simplemente el tráfico lo reciba el balanceador pero lo descarte. El otro es que el tráfico
			sea para el protocolo HTTP y se utilicen políticas de Capa 7 para su redireccionamiento.</li>
		</ul>
		</P>


		<h2>Protocolo del Punto de Acceso</h2>

		<P>
		El protocolo definido en el punto de acceso determina forma en la que se tratará el tráfico entrante. 
		<ul>	
			<li><b>HTTP: </b>Protocolo de capa de aplicación. Si deseamos redirigir tráfico mediante
			políticas de capa 7, debemos entonces utilizar este protocolo. Las políticas de capa 7 están
			destinadas a tráfico HTTP y permiten, en base a características que vienen en el encabezado HTTP,
			tomar acciones diversas como redirigir el tráfico a otro destino, balancearlo hacia cierto Grupo
			o hasta bloquear dicho tráfico. Cómo las políticas de capa 7 se basan en el encabezado HTTP, es
			necesario seleccionar este protocolo si se desea utilizarlas.
			Si el tráfico que vamos a manejar es del tipo HTTP y no pretendemos utilizar políticas de capa 7,
			podemos configurar el punto de acceso con el protocolo TCP puerto 80. En este caso el tráfico no es
			examinado a nivel HTTP y será enviado directamente al Grupo configurado. La ventaja radica en la
			menor carga de procesamiento que requiere el balanceador ya que no necesita desencapsular el
			paquete de datos para leer el encabezado HTTP, reduciendo tiempos y aceptando mayor cantidad de
			conexiones.</li>

			<li><b>HTTPS: </b> Similar al HTTP solo que no admite políticas de capa 7.</li>

			<li><b>TCP: </b> Protocolo de capa de enlace orientado a la conexión. Se debe seleccionar este
			protocolo cuando el tráfico es sabido que es de esta característica y no es HTTP o HTTPS.</li>

			<li><b>UDP: </b> Protocolo de capa de enlace orientado a datagramas. Se debe seleccionar este
			protocolo cuando el tráfico es sabido que es de esta característica.</li>

			<li><b>SCTP: </b> Es un protocolo de capa de enlace que posee características de los protocolos
			TCP y UDP.</li>
		</ul>
		</P>

		<h2>Restricciones de protocolos entre el Punto de Acceso y el Grupo</h2>
		<P>
		Si el punto de acceso se configura para enviar el tráfico a un grupo de balanceo, hay restricciones
		a considerar entre el protocolo del punto de acceso y el protocolo del grupo. Hay protocolos que no
		son compatibles entre sí. Si no son compatibles, la interfaz de {cloudName} te avisará y no te
		permitirá completar el alta del LBaaS o de un Punto de Acceso hasta que corrijas el problema. La siguiente
		tabla indica la compatibilidad entre el protocolo del punto de acceso y el protocolo del grupo.
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS08.png" alt="Compatibilidad listener Pool" style={{marginLeft:"40px"}} />
		</P>
	</Content>
	)
}

export const ConLBaaSL7 = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<H1>Políticas Capa 7</H1>
		<P>
		Nos permiten recibir tráfico HTTP y tomar acciones a nivel de capa de aplicación. Solo pueden utilizarse
		si el protocolo del Punto de Acceso es HTTP.
		</P>
		<h2>Políticas Capa 7</h2>
		<P>
		Para comprender cómo configurar la redirección del tráfico mediante políticas de capa 7, es necesario
		manejar bien los conceptos que determinan cómo se compone una URL. En la siguiente imagen se detallan
		las partes que componen una URL (Uniform Resource Locator).
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS09.png" alt="Partes de una URL" style={{marginLeft:"40px"}} />
		</P>
		<P>
		Las Políticas de capa 7 nos permiten modificar una URL para redirigir el tráfico HTTP hacia otro destino.
		Las acciones permitidas son las siguientes:
		<ul>
			<li><b>REDIRECT_PREFIX: </b> Permite mantener la parte de la URL relacionada con el recurso y cambiar
			la parte del prefijo. Por ejemplo, el tráfico llega con la URL
			<P style={{marginTop:"10px"}}><b>http://miempresa.com.ar</b>
			<b style={{color:"blue"}}>/recurso.html</b></P> y es redirigido a
			<P><b>https://www.otrositioweb.com.ar</b>
			<b style={{color:"blue"}}>/recurso.html. </b></P>
			Donde la parte de la URL en azul es la que se mantiene inmutable</li>
			<li><b>REDIRECT_TO_POOL: </b>Redirige el tráfico a un Grupo(Pool) en particular. Solo se puede
			redirigir a un grupo cuyo protocolo sea HTTP.</li>
			<li><b>REDIRECT_TO_URL: </b> Permite redirigir el tráfico alterando la URL por completo. Por ejemplo, el
			tráfico llega a la URL http://miembresa.com.ar/recurso.html y es redirigido a
			https://www.otro.sitioweb.com.ar/otrorecurso.htm</li>
			<li><b>REJECT: </b>Rechaza el tráfico informando de ello al origen.</li>
		</ul>
		</P>
		<P>
			Las políticas de capa 7 efectúan la acción indicada para todo tráfico que ingresa si no se definen reglas.
			Las reglas son por política. Una política puede tener cero o varias reglas. Como se ha indicado, si
			la política no posee reglas, se ejecutará. Si pose una o varias reglas, la política se ejecutará si al
			menos una de las reglas se cumple.
		</P>
		<P>
			Las reglas se conforman por los siguientes atributos
			<ul>
				<li><b>Tipo: </b>Determina el tipo de elemento del encabezado HTTP que se analizará para ver si
				se cumple o no la regla. Los valores posibles son:
					<ul>
						<li><b>COOKIE: </b> La existencia de una cookie de una clave dada con un valor dado.</li>
						<li><b>FILE_TYPE: </b> La existencia de un archivo con un nombre de tipo específico</li>
						<li><b>HEADER: </b> La existencia de un encabezado HTTP en particular con un valor dado</li>
						<li><b>HOST_NAME: </b>El nombre de un hostname en particular</li>
						<li><b>PATH: </b>Un camino a recurso dado</li>
						<li><b>SSL_CONN_HAS_CERT: </b>La regla se cumple si el cliente ha presentado un certificado
						para la autenticación TLS. Esto no implica que el certificado sea válido.</li>
						<li><b>SSL_VERIFY_RESULT: </b>Esta regla coincide con el resultado de la validación del
						certificado de autenticación del cliente TLS. Un valor de cero (0) significa que el
						certificado se validó correctamente. Un valor mayor que cero significa que el
						certificado no superó la validación. Este valor sigue a los códigos de resultado de
						openssl-verify.</li>
						<li><b>SSL_DN_FIELD:</b> La regla busca un campo de nombre distinguido definido en el
						parámetro clave y lo compara con el parámetro de valor en la regla.</li>
					</ul>
				</li>
				<li><b>Tipo de Comparación: </b> Permite determinar la comparación que se realiza con el Tipo de
				elemento del encabezado HTTP elegido. No todas los Tipo de Reglas soportan todos los tipos
				de comparaciones.
					<ul>
						<li><b>CONTAINS: </b> El texto del tipo seleccionado contiene el valor del atributo Valor.</li>
						<li><b>ENDS_WITH: </b> El texto del tipo seleccionado termina con el valor del atributo
						Valor.</li>
						<li><b>EQUAL_TO: </b> El texto del tipo seleccionado es igual al valor del atributo Valor.</li>
						<li><b>REGEX: </b> El texto del tipo seleccionado responde a la expresión regular indicada
						en el atributo Valor.</li>
						<li><b>STARTS_WITH: </b> El texto del tipo seleccionado comienza con el valor del atributo
						Valor.</li>
					</ul>
				</li>
				<li><b>Clave: </b>Utilizado solamente para indicar la cookie(tipo COOKIE) o el atributo del
				encabezado(HEADER) donde comprar el texto con el campo Value usando el Tipo de Comparación.</li>
				<li><b>Valor: </b>Es el valor a comparar según el Tipo de Comparación en el atributo seleccionado
				en el atributo Tipo</li>
				<li><b>Negado: </b>Indica que la validación se niega.</li>
			</ul>
		</P>
		<h3>Lógica de evaluación re las reglas</h3>
		<P>
			Cada Política de Capa 7 puede tener o no reglas asociadas. Si no posee reglas, entonces la política
			se aplicará. Si la Política de capa 7 posee reglas, las mismas deben validarse todas ellas (operació
			boolean AND) para que la política sea aplicada.
		</P>
		<P>
			Las políticas tienen un orden de presedencia y una vez que se aplica una política (porque valida todas
			sus reglas o porque no tiene reglas) las que le siguen no se aplican o evalúan sus reglas.
		</P>
		<h3>Ejemplos de reglas y políticas</h3>
		<P>
			Supongamos que tenemos dos microservicios en dos VM distintas que ofrecen API Rest a una APP para
			una librería. El microservicio A se encarga del Login de nuestra aplicación y el microservicio B
			se encarga de la gestión de Libros.

			Queremos entonces que nuestro LBaaS escuche en el protocolo HTTP y que todo lo que va dirigido
			a http://milibreria.com.ar/login sea redirigido al microservicio A y lo que vaya dirigido a
			http://milibreria.com.ar/article vaya dirigido al
			microservicio B. Cualquier otro caso se rechaza. Para ello ya hemos creado dos Grupos llamados
			"Grupo A" y "Grupo B" donde sus miembros son las VM donde se encuentran los microservicios.
		</P>
		<P>
			Creamos entonces tres políticas de capa 7. La primera llamada "login", la segunda llamada "ABM" y
			la tarcera llamada "rechazo". Para las dos primeras no importaría el orden. Pero la de nombre "rechazo"
			debe estar en último lugar ya que sino, a causa de que no tendrá ninguna regla, rechazaría todo el
			tráfico entrante. Recordar qué, la primer política que verifique sus reglas (si no tiene reglas se
			verifica por defecto), será la política que se aplique y no se evaluarán las siguientes.
		</P>

		<P>
			Siguiendo con el ejemplo configuramos nuestra primer política de nombre "login" como sigue:
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS10.png" alt="Partes de una URL" style={{marginLeft:"40px"}} />
		</P>
		<P>
			Y sus reglas serán las siguientes
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS12.png" alt="Partes de una URL" style={{marginLeft:"40px"}} />
		</P>
		<P>
			La política "ABM" la configuraríamos como sigue
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS11.png" alt="Partes de una URL" style={{marginLeft:"40px"}} />
		</P>
		<P>
			Y sus reglas serían
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS13.png" alt="Partes de una URL" style={{marginLeft:"40px"}} />
		</P>
		<P>
			Para finalizar, la política de nombre "rechazo" quedaría como sigue
		</P>
		<P>
			<img src="/img/LBaaS/LBaaS14.png" alt="Partes de una URL" style={{marginLeft:"40px"}} />
		</P>
		<P>
			Y la misma no posee reglas.
		</P>
	</Content>
	)
}

export const ConLBaaSMember = () => {
	const { cloudName } = useContext(DomainContext)

	return(
	<Content>
		<H1>Miembros de un Grupo</H1>

		<P>
		Los miembros son los hosts que formarán parte del balanceo a los cuales se les enviará
		el tráfico que recibe el LBaaS.
		</P>

		<P>
		Cada grupo posee sus propios miembros, pero nada impide que dos grupos distintos tengan
		configurados todos o algunos miembros iguales respecto a su IP.
		</P>

		<P>
		Cada miembro posee los siguientes atributos
		<ul>
			<li><b>Nombre:</b> Un nombre que identifique al miembro</li>

			<li><b>Estado Administrativo:</b> Determina si el miembro se encuentra en línea (ONLINE)
			o fuera de línea (OFFLINE). Éste estado es configurable por el usuario y sirve principalmente
			para indicarle al LBaaS que no debe enviar tráfico a este miembro. Por ejemplo… si se desean
			realizar tareas administrativas con afectación sobre el miembro.</li>

			<li><b>IP:</b> Es la IPv4 del miembro</li>

			<li><b>Backup:</b> Indica si el miembro debe tratárselo como backup. En modo backup, no forma
			parte de la selección por parte del LBaaS para determinar si el miembro debe recibir el
			tráfico entrante. El miembro comienza a formar parte de la selección cuando otro entra en
			estado offline, tomando el primero su lugar. Si el miembro original vuelve a estar en línea,
			el configurado como backup deja nuevamente de entrar en la selección. El modo backup solo tiene
			sentido si el Grupo al que pertenece (Ver la sección Grupo), tiene configurado un
			Monitor de Estado.</li>

			<li><b>Estado Operativo:</b> Determina cómo se encuentra operativamente el miembro.
			Los valores posibles son:
				<ul>
					<li><b>ONLINE</b>: El miembro está en condiciones de recibir tráfico según
					el chequeo realizado por el Monitor de estado que posee el Grupo. El LBaaS
					le está enviando tráfico al miembro</li>
					<li><b>OFFLINE</b>: El miembro fue removido explícitamente por el administrador
					del balanceo. El LBaaS no le envía tráfico al miembro.</li>
					<li><b>NO_MONITOR</b>: El Grupo no posee el monitoreo activado por lo que no
					es posible determinar si el miembro está en condiciones de recibir tráfico. Sin
					embargo, el LBaaS se lo está enviando. Se comporta como el ONLINEi.
					<Alert severity="error">
						Si el Grupo al que pertenece el miembro tiene activado el Monitor de estado
						y sin embargo el estado del miembro sigue siendo "Sin monitoreo", la causa
						debe ser que el LBaaS no puede alcanzar el servicio Monitoreado. Posiblemente
						a causa de que falta configurar correctamente los Grupos de Seguridad del
						miembro a ser monitoreado.
					</Alert>
					</li>
					<li><b>DRAINING</b>: El miembro no acepta más conexiones y mantendrá las que
					posee abiertas hasta que estas terminen. Una vez finalizada la última conexión,
					el puerto pasará al estado OFFLINE.</li>
				</ul>
			</li>

			<li><b>Puerto de protocolo:</b> Indica el puerto donde se encuentra escuchando el servicio en
			el miembro. Podría no coincidir con el puerto del Punto de Acceso (Ver Punto de Acceso) y esto
			permite hacer PAT. Donde el Punto de Acceso expone un puerto y luego se balancea hacia otro
			puerto en el miembro. El protocolo del miembor queda determinado por el Grupo al que pertenece.</li>

			<li><b>Peso:</b> El peso de un miembro determina la proporción de solicitudes o conexiones
			que atiende en comparación con los demás miembros del Grupo al que pertenece. Por ejemplo, un
			miembro con un peso de 10 recibirá cinco veces más solicitudes que uno con un peso de 2.
			Un valor de 0 significa que el miembro no recibe nuevas conexiones, pero continúa atendiendo
			las existentes hasta que se cierren. Un valor válido va de 0 a 256. El valor predeterminado es 1.</li>
		</ul>
		</P>
	</Content>
	)
}
export const ConLBaaSPool = () => {
	const { cloudName } = useContext(DomainContext)

    return(
	<Content>
		<H1>Grupos en un LBaaS</H1>

		<P>
		En un Balanceador pueden crearse lo que llamaremos Grupos. Los Grupos permiten definir los miembros
		que participarán del balanceo y la forma en la que se realiza dicho balanceo. Los miembros,
		detallados más adelante en el apartado “Miembros de un Grupo” son básicamente los hosts que
		recibirán el tráfico que ingresa al Balanceador.
		</P>

		<P>
		No siempre es necesario contar con un Grupo. Por ejemplo, si se desea redirigir el tráfico HTTP
		en base a algún atributo en el encabezado de dicho protocolo hacia otra URL. En este caso no es
		necesario contar con Grupos.
		</P>

		<h2>Estados de un Grupo</h2>

		<P>
			Un Grupo puede encontrarse en alguno de los siguientes estados:
			<ul>
				<li><b>ONLINE:</b> El grupo opera con normalidad. Todos los miembros del pool son
				monitoreados y operan con normalidad.</li>

				<li><b>OFFLINE:</b> El grupo se encuentra, de forma administrativa, fuera de línea.
				Significa que fue deliberadamente sacado de línea por el usuario</li>

				<li><b>DEGRADED:</b> Uno o varios miembros del grupo no operan con normalidad pero
				tiene al menos uno que sí opera con normalidad y por lo tanto se presta servicio</li>

				<li><b>ERROR:</b> Todos los miembros del grupo no operan con normalidad. No se está
				prestando servicio</li>

				<li><b>NO_MONITOR:</b> El grupo no se encuentra monitoreado y no se conoce el estado
				de sus miembros. Podría estar prestando servicio ya que con certeza solo se puede saber
				que no se encuentra OFFLINE.</li>
			</ul>
		</P>

		<h2>Atributos de un Grupo</h2>

		<P>
		Cada grupo posee los siguientes atributos en todos los casos
		<ul>
			<li><b>Nombre:</b> Es simplemente el nombre que le damos al grupo. Se recomienda que el nombre
			sea lo más descriptivo posible. Por ejemplo “Servidores Web”</li>

			<li><b>Protocolo:</b> El protocolo de red que utilizara el grupo para comunicarse con los
			miembros. Las opciones posibles son HTTP, HTTPS, PROXY, PROXYV2, SCTP, TCP, UDP. Ver sección
			<i> “Protocolos del Grupo”</i></li>

			<li><b>Modo de balanceo: </b>Es la forma en la que el LBaaS determina a cuál de los miembros del
			grupo dirigirle el tráfico. Las opciones son:
			<ul>
				<li><b>Secuencial (Round-Robin):</b> El tráfico se distribuye de manera secuencial. Esto
				significa que, si el grupo posee tres miembros, la primera petición se enviará al miembro 1,
				la segunda al miembro 2, la tercera al miembro 3, la cuarta al miembro 1 nuevamente y así en
				secuencia. Este comportamiento se repite siempre y cuando cada uno de los miembros se encuentre
				en estado <b>“Activo”</b> y siempre que los tráficos sean independientes entre ellos. Si los
				miembros poseen distinto <b>“peso”</b>, se dirigirán más peticiones a uno que a otro.</li>

				<li><b>IP de origen:</b> Determina el miembro al cual enviar el tráfico en base a la IP de
				origen. Mediante un hash, intenta balancear de forma más aleatoria que el método Secuencial.
				En la práctica es casi lo mismo, pero distribuye el tráfico un poco más aleatoriamente que el
				anterior.

				<Alert severity="error">
					El balanceo mediante IP no mantiene “persistencia por sesión” y ese tipo de
					configuración se detalla más adelante.
				</Alert>
				</li>

				<li><b>Menores conexiones:</b> Se enviará el tráfico al miembro que tenga actualmente menor
				cantidad de conexiones establecidas. Es la mejor opción si se desea que todos los miembros
				tengan una cantidad de conexiones similares.</li>
			</ul></li>
		</ul>
		</P>
		
		<h2>Protocolos</h2>
		<P>
		El protocolo en el Grupo determina la forma en que el tráfico será redirigido por el grupo a los
		miembros de éste. En los miembros no se determina el protocolo. Solamente el puerto al cual debe
		enviarlo el Grupo, siendo el protocolo el definido en el mismo.
		</P>

		<P>
			<ul>
				<li><b>HTTP:</b> Para tráfico Web.</li>
				<li><b>HTTPS:</b> Para tráfico Web sobre TLS/SSL. El certificado debe encontrarse en cada
				miembro del Grupo</li>
				<li><b>PROXY:</b> Permite conexiones TCP transparentes a los servidores backend sin
				modificar el tráfico. Se debe utilizar cuando se necesita que los servidores backend vean
				la dirección IP original del cliente.</li>
				<li><b>PROXY2:</b> Al igual que PROXY pero permiten tráfico binario.</li>
				<li><b>TCP:</b> Para tráfico TCP.</li>
				<li><b>UDP:</b> Para tráfico UDP.</li>
				<li><b>SCTP:</b> Para tráfico SCTP.</li>
			</ul>
		</P>

		<h2>Persistencia de sesión</h2>

		<P>
		Permite que, una vez que el protocolo de balanceo del Grupo ha seleccionado un miembro para un
		tráfico nuevo, los sucesivos tráficos que mantengan una característica con el primero,
		sigan siendo redirigidos al mismo miembro. Esto es útil cuando por ejemplo el servicio que
		estamos balanceando posee algún sistema de sesiones como por ejemplo sesiones web. Los tipos
		posibles son:
		</P>

		<ul>
			<li><b>IP de origen: </b>Se basa en la IP de origen. Todos los tráficos donde la IP de origen
			sea la misma, serán enviados al mismo miembro. Si el miembro quedase fuera de línea, se elige
			un nuevo miembro y nuevamente todo el tráfico, para la misma IP de origen, será enviada a este
			nuevo miembro elegido.</li>

			<li><b>Cookie en HTTP: </b>El balanceador inserta una cookie en la respuesta a la primera
			consulta que llega en el tráfico. Dicha cookie debe ser luego enviada por el cliente en las
			sucesivas consultas para que el balanceador la reconozca y envíe dichas consultas al mismo
			miembro.</li>

			<li><b>Cookie en App: </b>Permite indicar el nombre de una cookie en particular que vendrá en
			el header del paquete HTTP. Si el LBaaS encuentra dicha cookie, el tráfico será redirigido al
			mismo miembro.</li>
		</ul>

		<P>
		No todos los protocolos configurables en un grupo son compatibles con la característica de
		persistencia de sesión. La siguiente tabla refleja los protocolos compatibles según el tipo de
		persistencia de sesión seleccionado.
		</P>

		<P>
			<img src="/img/LBaaS/LBaaS06.png" alt="Compatiblidad grupo persistencia" style={{marginLeft:"40px"}} />
		</P>

		<H1>Monitor de Estado</H1>
		<P>
		El Monitor de Estado se encarga de determinar si un miembro del Grupo está en condiciones de
		recibir tráfico. Si el Monitor detecta que un miembro no puede recibir tráfico, lo retira de
		la selección cuando ingresa un nuevo tráfico. Si tenemos algún miembro configurado como Backup y
		está en condiciones de recibir tráfico según el Monito de Estado, éste entra en reemplazo del
		que fue retirado. Cuando el Monitor determina que ese mismo miembro retirado se encuentra
		nuevamente en condiciones de recibir tráfico, lo reingresa a la selección y retira el del backup
		si es que existiese y hubiese tomado el lugar del primero.
		</P>

		<P>
		El Monitor puede estar activo o no. Si no lo está, el LBaaS podría intentar enviar tráfico a
		un miembro del grupo que no puede atenderlo.
		</P>

		<P>
		Es recomendable tener activado y configurado siempre el Monitor de Estado en el Grupo en
		un LBaaS que ofrece un servicio en producción. Si no dispone de un Monitor de Estado, los
		miembros con errores no se retirarán del balanceo en el Grupo. Esto puede provocar interrupciones
		del servicio para los clientes.
		</P>

		<h2>Tipos de monitoreos</h2>

		<P>El tráfico que podemos balancear es variado y no siempre es una buena opción verificar que un
		miembro está en condiciones de manejarlo. Pongamos un ejemplo. Supongamos que tenemos un sitio web
		balanceado contra tres miembros. Cada miembro posee el sitio hosteado y utilizando el software Nginx
		como servicio HTTP. Intentaremos configurar un Monitor de Estado adecuado para el servicio. En una
		primera instancia podríamos suponer que si, el miembro responde a un PING entonces puede recibir tráfico.
		No está mal, el PING nos indicaría que el server está levantado. Pero no nos indica si el Nginx está
		corriendo. Mejoramos nuestro Monitor de Estado y cambiamos el PING por verificar que el puerto TCP 80
		responda. Mucho mejor. Con ello verificamos que el servicio HTTP del servidor responde y por ende
		el servidor está levantado. Pero el NGINX podría estar mal configurado o el sitio responder con un
		error 500 a causa de un BUG o error a causa de que la Base de datos no responde. Mejoramos nuestro
		Monitor de Estado enviando entonces a cada miembro una consulta HTTP usando el verbo GET pidiendo por
		la URL "www.misitio.com.ar/index.html" y esperando como respuesta el código 200. Como se puede ver,
		éste último Monitor de Estado es el más eficaz respecto del servicio que deseamos monitorear. Aún cuando
		los intentos anteriores no estaban incorrectos.
		</P>

		<P>
		Dependerá del protocolo del Grupo, la forma en la que se podrá constatar que los miembros de éste,
		estén en condiciones de recibir tráfico.
		</P>

		<Alert severity="error">
		Todos los chequeos son tráfico desde el LBaaS hacia el miembro. Por lo cual, se debe constatar que
		el tráfico pueda llegar desde el LBaaS hacia el miembro a ser monitoreado. Por ejemplo. Si se
		utiliza el tipo de Monitoreo PING, el tráfico ICMP debe poder salir del puerto del LB y llegar al
		puerto del miembro. Esto puede implicar reconfiguración de los Grupos de Seguridad o de reglas de
		Firewall en el propio miembro.
		</Alert>

		<P>
			A continuación se detallan los tipos de chequeos que admite un Monitor de Estado
		</P>

		<P>
		<ul>
			<li><b>PING:</b> El chequeo más básico. Verifica que el miembro responda al mensaje
			PING mediante el protocolo ICMP. Los Monitores de Estado de tipo PING solo comprueban si
			el miembro es accesible y responde a las solicitudes de eco ICMP. No detectarán si la
			aplicación que se ejecuta en esa instancia está en buen estado. La mayoría de los grupos
			deberían usar alguna de las otras opciones de monitorización de estado. PING solo debe usarse
			en casos específicos donde una solicitud de eco ICMP sea una comprobación de estado válida.</li>

			<li><b>HTTP:</b> El monitor de estado verifica que el miembro responda a consultas del
			protocolo HTTP. Por ejemplo, que ante un GET a la URL www.misition.com.ar/listado el miembro
			monitoreado responda con un estado 200.</li>

			<li><b>HTTPS:</b> Al igual que el monitoreo mediante HTTP pero usando HTTPS.</li>

			<li><b>TCP:</b> El Monitor abren una conexión TCP al puerto de protocolo del Miembro.
			Una aplicación TCP personalizada debe estar diseñada para responder correctamente a la
			conexión del balanceador de carga, abriendo una conexión TCP y cerrándola de nuevo tras
			el protocolo de enlace TCP sin enviar datos.</li>

			<li><b>SCTP:</b> El monitoreo envían un paquete INIT al puerto del servidor Miembro.
			Si una aplicación escucha en este puerto, el sistema operativo debería responder con un
			paquete INIT ACK; si el puerto está cerrado, responde con un paquete ABORT. Si el Monitoreo
			recibe un paquete INIT ACK, cierra inmediatamente la conexión con un paquete ABORT y considera
			que el servidor está en línea.</li>

			<li><b>TLS-HELLO:</b> El monitor garantizan que el servidor backend responda a los mensajes de
			saludo del cliente SSLv3. No verifican otras métricas de estado, como el código de estado o el
			contenido del cuerpo.</li>

			<li><b>UDP-CONNECT:</b> El Monitor realizan una conexión básica al puerto UDP. Es posible que
			estos Monitores no funcionen correctamente si la opción Destination Unreachable (ICMP type 3)
			no está habilitada en el servidor miembro o está bloqueada por una regla de seguridad. Un
			servidor miembro puede estar marcado como en línea cuando en realidad está inactivo.</li>
		</ul>
		</P>

		<h2>Restricciones del Monitor según el protocolo del Grupo</h2>

		<P>
			Los tipos de Monitor permitidos dependerán del protocolo del Grupo. La siguiente tabla
			indica los tipos de Monitor á poder configurar según el protocolo del Grupo
		</P>

		<P>
			<img src="/img/LBaaS/LBaaS07.png" alt="Compatiblidad grupo y monitores" style={{marginLeft:"40px"}} />
		</P>

		<h2>Configuración de un Monitor de Estado</h2>

		<P>
		La configuración del Monitor posee las siguientes propiedades para cualquiera de los tipos
		seleccionados:
			<ul>
				<li><b>Retraso (Delay):</b> Es el tiempo en segundos que aguarda el monitoreo para
				verificar nuevamente la salud de un host. Por defecto es de 5 segundos.</li>

				<li><b>Máximos intentos:</b> Es la cantidad de veces consecutivas que un host tiene que
				pasar afirmativamente el monitoreo para considerarlo “en línea”. El valor por defecto es 3.
				Considerando este valor y, que el tiempo entre chequeo y chequeo por defecto es de 5
				segundos, podemos deducir que deben pasar 15 segundos para que un host pasa a estado
				“fuera de línea” si tiene algún problema.</li>

				<li><b>Máximos intentos para caída:</b> Es la cantidad de veces consecutivas que un
				host tiene que fallar en el monitoreo para considerarlo en estado “fuera de línea”.
				El valor por defecto es 5. Considerando este valor y, que el tiempo entre chequeo y
				chequeo por defecto es de 5 segundos, podemos deducir que deben pasar 25 segundos para
				que un hosts pasa a estado “fuera de línea” si tiene algún problema.</li>

				<li><b>Tiempo máximo (timeout):</b> Es el tiempo máximo que aguarda el monitoreo para
				determinar que un host a fallado en el chequeo. El valor por defecto es 5 segundos. Por
				ejemplo, si el monitoreo es del tipo TCP al puerto 3306 y al realizar el chequeo la
				conexión TCP a dicho puerto tarda más de 5 segundos en establecerse, el monitoreo
				considera fallido el chequeo.</li>
			</ul>
		</P>
		<P>
			Si seleccionás el tipo HTTP o HTTPS se suman las siguientes tres propiedades:
			<ul>
				<li><b>Método HTTP:</b> Es el verbo del encabezado HTTP. Las opciones posibles son
				CONNECT, HEAD, OPTIONS, DELETE, GET, PUT, POST, PATCH y TRACE</li>

				<li><b>URL HTTP:</b> Es la URL a utilizar que, acompañada de la propiedad 'Método HTTP',
				se utiliza para contactar al servidor WEB del miembro</li>

				<li><b>Código HTTP esperado:</b> Es el código que se esperaría al llamar a la URl
				definida en el atributo URL HTTP para con el verbo definido en Método HTTP. Si el código
				retornado por el miembro al cual se está monitoreando retorna un código HTTP distinto del
				esperado, entonces se considera que no ha pasado el test del monitoreo y se lo colocará
				en estado “offLine”.</li>
			</ul>
		</P>
	</Content>
	)
}
